export default "__VITE_ASSET__E66or9Tx__"